module.exports = {"thousand":"tis.","million":"mil.","billion":"mld.","trillion":"bil.","":" ","undefined":" "}